import { useMemo } from 'react';

import { Common } from '@thecvlb/design-system/lib/src';
import classNames from 'classnames';
import { compare, validate } from 'compare-versions';
import { useGetMinAppVersionQuery } from 'store/versions/versionsApi';

import { version } from '../../../../package.json';

const UpdatePortalBanner = () => {
  const { data } = useGetMinAppVersionQuery(null, {
    pollingInterval: 1000 * 60 * 10
  }); // run query every 10 minutes
  const showBanner = useMemo(() => {
    const newVersion = data?.physician.min || '';

    if (validate(newVersion) && compare(newVersion, version, '>')) return true;
    return false;
  }, [data?.physician?.min, version]);

  const handleUpdate = () => {
    window.location.reload();
  };

  const bannerClasses = classNames(
    'fixed inset-x-0 top-0 z-[9999] flex w-full items-center justify-center gap-y-2 bg-yellow-100 px-10 py-2 shadow-md',
    {
      hidden: !showBanner
    }
  );

  return (
    <div className={bannerClasses}>
      <div className="flex flex-1 items-center">
        <Common.Icon name="repeat" className="size-5 text-yellow" />
        <span className="ml-1 text-base font-bold text-gray-700">LifeMD update required</span>
        <p className="mx-2 text-base text-gray-700">
          To ensure smooth functionality and access to new features, please update LifeMD.
        </p>
      </div>
      <Common.Button size="sm" color="white-alt" onClick={handleUpdate}>
        Update LifeMD
      </Common.Button>
    </div>
  );
};

export default UpdatePortalBanner;
